module.exports = __webpack_public_path__ + "static/media/swiperr-splash.26a8d603.png";